/**
 * @memberof module:util
 * @function
 * @name chunkString
 * @description Split a string into chunks to show in dropdown option in form options
 *
 * @param {string} str - string to be split in pieces
 * @param {number} length - size of the chunks of the string
 * @returns {Array}
 *
 * @example
 * console.log(chunkString("Pickup at port warehouse, no truck...",23)); //["Pickup at port warehous","e, no truck..."]
 */
export const chunkString = (str, length) => {
  const tempLen = `${length}`;
  return str.match(new RegExp('.{1,' + tempLen + '}', 'g')) || [];
};
